module.exports = __webpack_public_path__ + "img/csv.eeafcc94.svg";